<template>
  <div>
    <!-- 引入头部组件 -->
    <div class="cate">
      <div class="cate_police">
        <div class="cate-all">级别分类：</div>
        <div class="subject">
          <span
            v-for="(item, index) in rankClass"
            :key="index"
            :class="{heightlight : rankindex==index}"
            @click="rankArea(index,item)"
          >{{ item.name }}</span>
        </div>
      </div>

      <div class="cate_police">
        <div class="cate-all">教官类别：</div>
        <div class="subject">
          <span
            v-for="(item, index) in drillmasterClass"
            :key="index"
            :class="{heightlight : drillmasterindex==index}"
            @click="drillmasterArea(index,item)"
          >{{ item.name }}</span>
        </div>
      </div>

      <div style="border-bottom: 1px solid #dcdfe6;" class="cate_police">
        <div class="cate-all">全部警种：</div>
        <div ref="jzlistobjertwo" :class='["subject", jzlist&&putaway ? "hiddenlist" : ""]'>
          <span
            v-for="(item, index) in policeClassification"
            :key="index"
            :class="{heightlight : policeClassindex==index}"
            @click="policeClassArea(index,item)"
          >{{ item.name }}</span>
          <div v-if="jzlist&&putaway" class="showlist" @click="()=>{putaway = !putaway}">
            <span>更多</span>
            <i class="el-icon-caret-bottom"></i>
          </div>
          <div v-if="jzlist&&!putaway" class="showlist" @click="()=>{putaway = !putaway}">
            <span>收起</span>
            <i class="el-icon-caret-top"></i>
          </div>
        </div>
      </div>

      <!-- <div class="cate_police">
            <div class="cate-all">地市/州 ：</div>
            <div class="subject">
            <span
                v-for="(item, index) in cityList"
                :key="index"
                :class="{heightlight : cityIndex==index}"
                @click="selectCity(index,item)"
            >
                {{ item.name }}
            </span>
            </div>
      </div>-->
    </div>

    <div class="box">
      <div class="boxData">
        <div class="searchModel" style="display:flex;align-items: center;">
          <div class="subject" style="padding-right: 30px;"></div>
          <el-input
            @keyup.enter.native="keySearch"
            size="large"
            placeholder="请输入搜索内容"
            v-model="listQuerya.Name"
            class="input-with-select"
            style="width:287px;height:40px;font-size:16px;border-radius:4px;flex-shrink: 0;"
          >
            <el-button
              slot="append"
              @click="keySearch"
              icon="el-icon-search"
              style="background:#51565C;border-radius:0px;height:100%;color:white;font-size:16px;"
            ></el-button>
          </el-input>
        </div>
        <template>
          <v-teacher-data :listQuerys="listQuerya" :key="timer"></v-teacher-data>
        </template>
      </div>
      <div>
        <div class="boxDatashow">
          <template>
            <v-teaching-exper></v-teaching-exper>
          </template>
        </div>
        <div class="boxDatashow">
          <template>
            <v-teacher-blot></v-teacher-blot>
          </template>
        </div>
        <div class="boxDatashow">
          <template>
            <v-teacher-category></v-teacher-category>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCity } from '@/api/public.js';
import * as teacherInfo from '@/api/teacher/teacherInfo';
import vHeader from '../header/index';
import vTeacherData from './components/teacherdata/index';
import vTeachingExper from './components/teachingExperience/index';
import vTeacherBlot from './components/teacherblot/index';
import vTeacherCategory from './components/teacherCategory/index';
import linecom from '@/components/linecom/index';
export default {
  components: {
    vHeader,
    vTeacherData,
    vTeachingExper,
    vTeacherBlot,
    vTeacherCategory,
    linecom,
  },
  data() {
    return {
      cityList: [{ name: '全部', id: 0 }],
      cityIndex: 0,
      newList: [
        { subType: 0, name: '最新' },
        { subType: 1, name: '最热' },
      ],
      newIndex: 0,
      input3: '',
      policeClassification: [{ name: '全部', id: 0 }], //全部警种
      policeClassindex: 0, //高亮默认为全部
      drillmasterClass: [{ name: '全部', id: 0 }], //教官类别
      drillmasterindex: 0, //高亮默认为全部
      rankClass: [{ name: '全部', id: 0 }], //级别分类
      rankindex: 0, //高亮默认为全部
      drillmasterProperty: ['全部', '理论教官', '实战教官'], //教官属性
      Propertyindex: 0, //高亮默认为全部
      searchindex: 0, //高亮默认为全部
      searchdata: ['全部', '最新', '最热'],
      listQuery: {
        // 查询字典条件
        page: 1,
        limit: 30,
        key: null,
        namespaceId: null,
      },
      listQuerya: {
        // 查询教师数据库条件
        page: 1,
        limit: 10,
        key: null,
        Name: null,
        jzDicId: null, //警种
        typeDicId: null, // 教官类别
        jbDicId: null, //教官级别
        lrfz: null, //实战或理论
        PassStatus: 1, //审核通过的显示在前端页面
        ishome: true,
      },
      timer: '',
      jzlist: false,
      putaway: true,
    };
  },
  mounted() {
    this.getDishi();
    this.getPmiDictionary(1, this.policeClassification); //获取警种数组
    this.getPmiDictionary(7, this.drillmasterClass); //获取教官类别数组
    this.getPmiDictionary(69, this.rankClass); //获取教官级别数组
  },
  methods: {
    //查询新热
    policeNew(index, item) {
      this.newIndex = index;
    },
    policeClassArea(index, item) {
      this.policeClassindex = index;
      if (item.id == 0) {
        this.listQuerya.jzDicId = null;
      } else {
        this.listQuerya.jzDicId = item.id;
      }
      this.timer = new Date().getTime();
    },
    drillmasterArea(index, item) {
      this.drillmasterindex = index;
      if (item.id == 0) {
        this.listQuerya.typeDicId = null;
      } else {
        this.listQuerya.typeDicId = item.id;
      }
      this.timer = new Date().getTime();
    },
    rankArea(index, item) {
      this.rankindex = index;
      if (item.id == 0) {
        this.listQuerya.jbDicId = null;
      } else {
        this.listQuerya.jbDicId = item.id;
      }
      this.timer = new Date().getTime();
    },
    searchArea(index, item) {
      this.searchindex = index;
    },
    PropertyArea(index, item) {
      this.Propertyindex = index;

      if (item == '全部') {
        this.listQuerya.lrfz = null;
      } else if (item == '实战教官') {
        this.listQuerya.lrfz = 1;
      } else {
        this.listQuerya.lrfz = 0;
      }
      this.timer = new Date().getTime();
    },
    keySearch() {
      this.timer = new Date().getTime();
    },
    //查询地市
    selectCity(index, item) {
      this.cityIndex = index;
    },
    //获取地市
    getDishi() {
      getCity().then((res) => {
        res.result.forEach((e) => {
          this.cityList.push({ name: e.name, id: e.id });
        });
      });
    },
    //获取字典数据  index代表namespaceId，arr代表传出的数组
    getPmiDictionary(index, arr) {
      this.listQuery.namespaceId = index;
      teacherInfo
        .getPmiDic(this.listQuery)
        .then((response) => {
          response.result.forEach((e) => {
            arr.push({ name: e.name, id: e.id });
          });
          this.$nextTick(()=>{
            if(this.$refs.jzlistobjertwo.clientHeight > 42){
              this.jzlist = true
            }
          })
          // console.log(response.data.name)
        })
        .catch(() => {
          // debugger
        });
    },
  },
};
</script>
<style scoped>
.nav {
  width: 1200px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  margin: 0 auto;
  margin-top: 5px;
}
.nav > div {
  font-size: 19px;
  margin-left: 32px;
  padding-top: 0px;
}
.navpolice {
  font-size: 19px;
  margin-left: 32px;
  padding-top: 5px;
  display: flex;
}
.navpolice > div:nth-child(1) {
  flex: 1;
}
.navpolice > div:nth-child(2) {
  flex: 11;
}
.navpolice > div {
  margin-bottom: 7px;
  display: flex;
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.navpolice > div > div {
  line-height: 30px;
  font-size: 16px;
  color: #333333;
  margin-left: 20px;
  margin-top: 10px;
  background: #ececec;
  opacity: 1;
  border-radius: 6px;
  padding-left: 10px;
  padding-right: 10px;
}

/* 高亮 */
.heightlight {
  background-color: #649FED !important;
  color: #f8fafc !important;
}
.box {
  margin: 0 auto;
  width: 1200px;
  min-height: 1340px;
  margin-top: 14px;
  display: flex;
  justify-content: space-between;
  padding: 21px 14px 0px 14px;
  box-sizing: border-box;
  background: linear-gradient(to bottom, #97CAF4 0%,#fff 300px,#fff 100%);
  border-radius: 4px;
}
.box > div:nth-child(1){
  margin-bottom: 10px;
  width: 846px;
}
.box > div:nth-child(2) {
  margin-left: 20px;
  width: 303px;
}
.box > div:nth-child(2) > div{
  width: 303px;
  margin-bottom: 12px;
}


.search {
  width: 1200px;
  height: 60px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  opacity: 1;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}
.search > div:nth-child(1) {
  display: flex;
}

.search > div:nth-child(1) > div {
  line-height: 30px;
  font-size: 16px;
  color: #333333;
  margin-left: 20px;
  margin-top: 15px;
  background: #ececec;
  opacity: 1;
  border-radius: 6px;
  margin-bottom: 15px;
  /* padding: 6px,12px; */
  padding-left: 10px;
  /* padding-top: 3px; */
  padding-right: 10px;
  /* padding-bottom: 3px; */
}
.search > div:nth-child(2) {
  padding: 10px 30px;
}

.cate {
  box-sizing: border-box;
  width: 1200px;
  background: #ffffff;
  margin: 0 auto;
  margin-top: 14px;
  border-radius: 4px;
  padding: 44px 28px 27px 35px;
}
.cate_police {
  display: flex;
  font-size: 16px;
}

.cate_police + .cate_police{
  margin-top: 12px;
}

.cate-all{
  width: 76px;
  font-size: 14px;
  line-height: 21px;
  margin-right: 10px;
}
.subject {
  position: relative;
  overflow: hidden;
  width: 100%;
  box-sizing: border-box;
  padding-right: 80px;
  display: flex;
  flex-wrap: wrap;
}
.subject > span {
  cursor: pointer;
  font-size: 14px;
  line-height: 22px;
  height: 22px;
  padding: 0px 10px;
  color: #000;
  border: 1px solid white;
  border-radius: 4px;
  margin-right: 10px;
  margin-bottom: 20px;
}
.subject > span:hover {
  border: 1px solid #649FED;
  color: #649FED;
  border-radius: 4px;
}

/deep/.input-with-select input{
  border-radius: 4px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}
/deep/.input-with-select .el-input-group__append{
  border-color: #51565C;
}

.boxData {
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  background-color: #fff;
}

.searchModel{
  position: absolute;
  right: 10px;
  top: 10px;
}

.boxDatashow {
  box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  background-color: #fff;
}

.subject >.showlist{
  position:absolute;
  z-index: 3;
  right: 5px;
  top: 0px;
  padding-left: 10px;
  cursor: pointer;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  color: #4D515A;
}
.hiddenlist{
  height: 42px;
}
</style>